var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { MiniHeaderCore } from '@core-front/mini-header';
import { getBackgroundColorClass } from '@telia-front/colors';
import Container from '@telia-front/container';
import Languages from '@telia-front/languages';
import Logo from '@telia-front/logo';
import SkipLinks from '@telia-front/skip-links';
const MiniHeader = (props) => {
    const { className, theme, logo, background } = props, rest = __rest(props, ["className", "theme", "logo", "background"]);
    const backgroundColor = React.useMemo(() => {
        if (background) {
            return background;
        }
        if (theme === 'dark') {
            return 'primary-5';
        }
        return;
    }, [background, theme]);
    const BEM = () => {
        const classArray = [];
        if (backgroundColor) {
            classArray.push(getBackgroundColorClass(backgroundColor));
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const MiniHeaderLogo = React.useCallback(() => React.createElement(Logo, Object.assign({}, logo, { size: "small", theme: (logo === null || logo === void 0 ? void 0 : logo.theme) || theme })), [theme, logo]);
    const MiniHeaderLanguages = React.useCallback((langProps) => React.createElement(Languages, Object.assign({}, langProps, { theme: theme })), [theme]);
    return (React.createElement(MiniHeaderCore, Object.assign({}, rest, { externalLogo: !!logo, className: BEM(), components: {
            Container,
            Languages: MiniHeaderLanguages,
            Logo: MiniHeaderLogo,
            SkipLinks,
        } })));
};
export { MiniHeader as default };
